// Historical entries distinguish verified website downloads from development candidates.
// Evidence: extension TESTING.md, store-submission verification records, and
// output/tutti-all-free-2026-10-04 / output/tutti-x-sidebar-v08*.
// null dates are intentional: no single supported date exists for that grouped milestone.
export const TUTTI_CHANGELOG_PATH = '/tutti-helper/changelog';

export const TUTTI_STORE_STATUS = {
  version: '0.10.0',
  status: 'published',
  checkedAt: '2026-10-08',
  storeUrl: 'https://chromewebstore.google.com/detail/tutti-activity-helper/fgojhpcaknpmfmpcaiflfjnbmgjmddoj',
};

export const TUTTI_RELEASES = [
  {
    version: '0.10.0',
    date: '2026-10-05',
    channel: 'website',
    title: { zh: '助推原帖列表与更稳定的 X 提醒', en: 'Boost post lists and more reliable X highlights' },
    changes: {
      zh: [
        '已加入且仍可助推的创作活动新增可展开的原帖列表，插件与 X 侧栏可查看待助推数、作者、摘要、发布时间、浏览和点赞信息，并跳转原帖或可用的引用、回复、转发入口。数据不完整或状态待确认时，不显示确定的待助推数。',
        '活动助推原帖出现在 X 时间线或个人主页时，也能显示活动提醒；按原帖匹配，不把帖内引用的内容误当成当前帖子。',
        '新增 Tutti 官方青绿色作为新设置的默认提醒颜色，保留金色、彩虹、自定义颜色及已有选择。',
        '修复时间线提示挤压正文与媒体的问题，让装饰边框位于图片、轮播和视频下方，保持媒体尺寸与点击操作。',
        '修复 X 页面样式导致侧栏登录绿点变灰、倒计时圆环消失的问题；后台短暂断开后自动重连，避免卡在刷新状态。',
        '助推作者名可直接打开 X 主页；活动结束、截稿和帖子发布时间按浏览器本地时间显示，中英文均包含年份。',
        '全部功能继续免费。本次更新官网下载包；详细引用审核、回复次数与奖励结算仍以 Tutti 活动页面为准。',
      ],
      en: [
        'Joined creator campaigns that are still open for boosting now have expandable post lists in the popup and X sidebar. See pending counts, authors, excerpts, publication times, views and likes, with links to originals and available quote, reply and repost actions. Incomplete data or unknown status does not produce an exact pending count.',
        'Boost originals can now show campaign highlights in X timelines and profile feeds. Matching uses the original post, without mistaking an embedded quote for the current post.',
        'Added Tutti’s official teal as the default highlight color for new settings, while preserving gold, rainbow, custom colors and existing choices.',
        'Fixed notices squeezing post text and media. Decorative outlines now sit beneath images, carousels and videos, preserving media size and click behavior.',
        'Fixed X styles turning the sidebar’s signed-in indicator gray or hiding its countdown ring. The sidebar reconnects after temporary background interruptions and recovers from stalled refreshes.',
        'Boost author names now link directly to X profiles. Campaign end times, submission deadlines and post timestamps use browser local time, with years included in both languages.',
        'All features remain free. This updates the website download; detailed quote reviews, reply counts and reward settlement remain available on Tutti’s campaign pages.',
      ],
    },
  },
  {
    version: '0.9.1',
    date: '2026-10-05',
    channel: 'website',
    title: { zh: '活动机会与设置分栏', en: 'Separate tabs for opportunities and settings' },
    changes: {
      zh: ['插件默认打开「活动机会」，集中展示活动搜索、筛选、报价和参与入口。', '「设置」集中收纳登录及相关链接、监控间隔、通知、提示音和 X 页面选项。', '标题与页签固定显示，内容独立滚动；切换页签会保留搜索内容和筛选条件。', '官网首页与开发手记同步新版中英文交互演示，可切换活动和设置查看；活动与报价均为示例。', '全部功能继续免费开放。本次仅更新官网下载包，Chrome 商店版本及原审核记录保持不变。'],
      en: ['The popup now opens on Activities, bringing campaign search, filters, rewards and participation links together.', 'Settings now groups sign-in and related links, check intervals, notifications, sounds and X page options.', 'The header and tabs stay visible while content scrolls independently. Search and filters are preserved when switching tabs.', 'The landing page and maker’s notes now share an updated bilingual interactive preview, with Activities and Settings tabs and clearly labeled sample data.', 'All features remain free. This release updates the website download only; the Chrome Web Store version and existing review record are unchanged.'],
    },
  },
  {
    version: '0.9.0',
    date: '2026-10-05',
    channel: 'website',
    title: { zh: '时间线活动提醒与可折叠侧栏', en: 'Timeline highlights and a collapsible sidebar' },
    changes: {
      zh: ['新增默认关闭的 X 时间线活动提醒：匹配进行中活动的原帖时，显示提示卡、边框和菜单左侧的 tutti 标记；可选金色、彩虹或自定义颜色。', 'X 侧栏支持折叠和圆环倒计时；折叠暂停当前页面更新，后台检查和通知继续运行。', '侧栏增加登录状态提示：已登录显示呼吸绿点，未登录显示灰点；已登录且有未读活动时，显示旋转两圈后清脆落地回弹的 3D 金币。', '全部功能继续免费开放。官网赞助入口统一使用 PeaceTech Ko-fi；本次更新的是官网下载包，商店仍保留原审核记录。'],
      en: ['Added optional X timeline highlights, off by default: matched active campaign posts show a notice, outline and tutti marker beside the menu, with gold, rainbow or custom colors.', 'The X sidebar now collapses and shows a countdown ring. Collapsing pauses that page’s updates while background checks and notifications continue.', 'Added sign-in indicators: a breathing green dot when signed in and a gray dot when signed out. Signed-in users with unread campaigns see a 3D coin that makes two turns before a crisp landing bounce.', 'All features remain free. Website support links now use PeaceTech Ko-fi. This is a website download release; the existing store review record is unchanged.'],
    },
  },
  {
    version: '0.8.2',
    date: '2026-10-04',
    channel: 'website',
    title: { zh: 'X 侧栏排版修复', en: 'X sidebar layout fix' },
    changes: {
      zh: ['修复 X 固定搜索框遮住「Tutti 助手」标题的问题。', '卡片与直播、趋势栏保持一致间距；保留 X 原有搜索占位和页面内容。'],
      en: ['Fixed the pinned X search box overlapping the Tutti Helper title.', 'Matched spacing between sidebar sections while preserving X’s search placeholder and native content.'],
    },
  },
  {
    version: '0.8.1',
    date: '2026-10-04',
    channel: 'internal',
    title: { zh: '侧栏刷新与隐藏', en: 'Refresh and hide from the sidebar' },
    changes: {
      zh: ['卡片增加「Tutti 助手」标题和「试试刷新」，可以直接检查最新活动。', '隐藏卡片会同步关闭插件侧栏开关；可在插件里重新开启。'],
      en: ['Added the Tutti Helper title and a Refresh control to check for updated campaigns.', 'Hiding the card also turns off the popup’s sidebar switch; enable it again from the extension.'],
    },
  },
  {
    version: '0.8.0',
    date: '2026-10-04',
    channel: 'internal',
    title: { zh: '把活动放进 X 右侧栏', en: 'Tutti campaigns in X’s sidebar' },
    changes: {
      zh: ['新增可选 X 侧栏：一个主要活动，其余活动展开查看。', '默认关闭，主动开启并授权后展示已同步活动；支持中英文和浅色、深色主题。'],
      en: ['Added an optional X sidebar with one featured campaign and an expandable list of the rest.', 'Off by default and enabled with your permission; shows synchronized campaigns in Chinese or English with light and dark themes.'],
    },
  },
  {
    version: '0.7.0',
    date: '2026-10-04',
    channel: 'website',
    title: { zh: '全部功能免费开放', en: 'All features made free' },
    changes: {
      zh: ['每分钟检查、桌面通知、未读提醒和金币提示音向所有用户开放，无需 PeaceTech 账号、绑卡或订阅。', '官网隐藏新订阅入口，赞助改为自愿支持，不影响功能。', '提交 Chrome 商店审核；提交审核不等于已经上架。'],
      en: ['Made minute-by-minute checks, desktop alerts, unread reminders and coin sounds available without a PeaceTech account, card or subscription.', 'Removed new-subscription offers from the website; optional support does not unlock features.', 'Submitted for Chrome Web Store review; submission does not mean store approval.'],
    },
  },
  {
    version: '0.6.2',
    date: '2026-10-03',
    channel: 'internal',
    title: { zh: '历史会员方案候选包', en: 'Historical membership candidate' },
    changes: {
      zh: ['为当时的会员方案准备正式环境候选包及中英文隐私说明，未提交商店。', '记录时新订阅仍关闭；会员功能区分后来已被 0.7.0 的全面免费政策取代。'],
      en: ['Prepared a production-environment membership candidate and bilingual privacy information; it was not submitted to the store.', 'New subscriptions remained closed at that stage. Version 0.7.0 later replaced these feature tiers with free access for everyone.'],
    },
  },
  {
    version: '0.6.0–0.6.1',
    date: '2026-10-02',
    channel: 'website',
    title: { zh: '历史免费版与会员版调整', en: 'Historical free and member tiers' },
    changes: {
      zh: ['0.6.0 提供每 30 分钟免费自动检查，0.6.1 调整为每 2 小时；保留手动刷新和活动入口。', '当时会员方案包含更快检查和提醒，但公开下载包未启用收费；这些区分已在 0.7.0 取消。'],
      en: ['Version 0.6.0 offered free checks every 30 minutes; 0.6.1 changed that interval to 2 hours while retaining manual refresh and campaign links.', 'The member tier covered faster checks and alerts, but billing was not enabled in the public download. Version 0.7.0 removed these distinctions.'],
    },
  },
  {
    version: '0.5.x',
    date: null,
    channel: 'internal',
    title: { zh: '账号连接与会员状态试验', en: 'Account connection and membership experiments' },
    changes: {
      zh: ['在测试版本中验证账号连接和会员状态，改善未连接提示与连接入口。', '历史记录中的公开 0.5.0 下载保持免费；这里记录的是会员测试，已由 0.7.0 的全面免费政策取代。'],
      en: ['Tested account connections and membership status, improving disconnected-state messages and connection entry points.', 'Historical records describe the public 0.5.0 download as free; this entry covers membership testing, which 0.7.0 later replaced with free access.'],
    },
  },
  {
    version: '0.4.1',
    date: '2026-09-24',
    channel: 'internal',
    title: { zh: '收窄权限并补充邀请说明', en: 'Reduced permissions and referral disclosure' },
    changes: {
      zh: ['移除旧的网页解析入口及相应注入权限，保留 Tutti API 读取。', '中英文登录入口补充开发者推荐奖励说明；当时仅为本地商店候选包。'],
      en: ['Removed legacy page parsing and its injection permissions, retaining Tutti API reads.', 'Added bilingual referral-reward disclosure to sign-in entry points; this remained a local store candidate.'],
    },
  },
  {
    version: '0.4.0',
    date: '2026-09-23',
    channel: 'internal',
    title: { zh: '无需保留 Tutti 页面', en: 'Checks without an open Tutti tab' },
    changes: {
      zh: ['转向后台只读 API 检查，增加请求超时、限流退避和账号切换处理。', '显示实际加载版本及提示音播放结果，方便判断声音或旧版本问题。'],
      en: ['Moved checks to read-only background APIs with timeouts, rate-limit backoff and account-change handling.', 'Displayed the loaded extension version and sound playback results to help diagnose sound or outdated-install issues.'],
    },
  },
  {
    version: '0.3.0',
    date: '2026-09-23',
    channel: 'internal',
    title: { zh: '金币提示音', en: 'Coin sound alerts' },
    changes: {
      zh: ['新增默认关闭的金币提示音和独立试听。', '新活动每批只响一次，首次同步和重复活动保持安静；声音与桌面通知分别控制。'],
      en: ['Added an optional coin sound, off by default, and an independent preview.', 'Plays once per new-campaign batch, staying quiet on initial sync and repeats; sound and desktop alerts have separate controls.'],
    },
  },
  {
    version: '0.2.0–0.2.1',
    date: '2026-09-23',
    channel: 'internal',
    title: { zh: '中英双语与检查稳定性', en: 'Chinese, English and more reliable checks' },
    changes: {
      zh: ['0.2.0 增加中英文切换、浏览器语言跟随及双语提醒。', '0.2.1 改善旧版网页检查的等待时间和超时恢复，减少慢加载导致的失败。'],
      en: ['Version 0.2.0 added Chinese and English controls, browser-language matching and bilingual alerts.', 'Version 0.2.1 improved waiting and timeout recovery in the earlier page-based checker.'],
    },
  },
  {
    version: '0.1.0',
    date: '2026-09-23',
    channel: 'internal',
    title: { zh: '首个本地版本', en: 'First local version' },
    changes: {
      zh: ['查看 Tutti 活动、定时检查、未读提醒和活动筛选。', '快捷打开活动详情及 X 引用、回复、转发页面，最终操作由你确认。'],
      en: ['Introduced Tutti campaign browsing, scheduled checks, unread reminders and filters.', 'Opened campaign details and X quote, reply or repost pages for you to review and complete.'],
    },
  },
];
